import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import AssistantPage from './AssistantPage.vue';

// Every user may use Zuwad AI; each sees only their own chats (enforced by the API).
const meta = { permissions: [...ROLES, 'custom_role'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/zuwad-ai'),
    name: 'zuwad_assistant',
    component: AssistantPage,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/zuwad-ai/:threadId'),
    name: 'zuwad_assistant_thread',
    component: AssistantPage,
    meta,
  },
];
